"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Data_1 = require("../Common/Data");
var ValuationWidgetContext_1 = require("../Context/ValuationWidgetContext");
var hooks_1 = require("preact/hooks");
var localization = window.Resources.ValuationWidgetResources;
var VinCorrectionSelector = function (_a) {
    var currentVin = _a.currentVin, onCorrectedVinClick = _a.onCorrectedVinClick, onYearMakeModelLinkClick = _a.onYearMakeModelLinkClick;
    // Basically switching out invalid characters with their possible alternatives.
    // IFALP4445SF148387 => 1FALP4445SF148387
    var widgetContext = (0, hooks_1.useContext)(ValuationWidgetContext_1.ValuationWidgetContext);
    var getMisreadVinDropdown = function () {
        var options = [];
        var correctedCharacters = [];
        var bestMatch = currentVin;
        if (!currentVin)
            return options;
        var easyFixes = Data_1.invalidVinMatches.filter(function (x) { return x.possibleMatches.length === 1; });
        var neededEasyFix = easyFixes.some(function (v) { return currentVin.indexOf(v.invalidChar) >= 0; });
        easyFixes.forEach(function (x) {
            bestMatch = bestMatch.replace(new RegExp(x.invalidChar, 'g'), x.possibleMatches[0]);
        });
        var _loop_1 = function (i) {
            var current = bestMatch.charAt(i);
            correctedCharacters.push(current);
            var invalidMatch = Data_1.invalidVinMatches.filter(function (x) { return x.invalidChar === current; });
            if (!invalidMatch)
                return "continue";
            invalidMatch.map(function (x) { return x.possibleMatches; })
                // Flatten array
                .reduce(function (acc, val) { return acc.concat(val); }, [])
                .forEach(function (x) {
                var fixedString = bestMatch.replace(new RegExp(current, 'g'), x);
                options.push(fixedString);
            });
        };
        for (var i = 0; i < bestMatch.length; i++) {
            _loop_1(i);
        }
        if (options.length === 0 && neededEasyFix)
            options.push(bestMatch);
        return options.filter(function (v, i, s) { return s.indexOf(v) === i; });
    };
    var getFragment = function () {
        var _a, _b;
        var showDropdowns = widgetContext.configuration.showDropdowns;
        if (showDropdowns) {
            return (0, preact_1.h)(preact_1.Fragment, null,
                (0, preact_1.h)("span", { class: "field-validation-error invalid-vin-character-warning" }, localization.Warning_InvalidVinWarningTitle),
                (0, preact_1.h)("div", { id: "dropdown" },
                    (0, preact_1.h)("div", { class: "dropdown-header" }, localization.Warning_InvalidVinWarningInvalidCharacterMessage),
                    (0, preact_1.h)("div", { class: "dropdown-header" },
                        localization.Warning_InvalidVinWarningWeFoundAlternativesIntroText,
                        " ",
                        localization.Warning_InvalidVinOr,
                        (0, preact_1.h)("a", { class: "green-link", onClick: onYearMakeModelLinkClick }, localization.Warning_InvalidVinWarningWeFoundAlternativesLinkText),
                        " "), (_a = getMisreadVinDropdown()) === null || _a === void 0 ? void 0 :
                    _a.map(function (x) { return (0, preact_1.h)("div", { class: "dropdown-item", onClick: function () { return onCorrectedVinClick(x); }, className: "dropdown-item" }, x); })));
        }
        else {
            return (0, preact_1.h)(preact_1.Fragment, null,
                (0, preact_1.h)("span", { class: "field-validation-error invalid-vin-character-warning" }, localization.Warning_InvalidVinWarningTitle),
                (0, preact_1.h)("div", { id: "dropdown" },
                    (0, preact_1.h)("div", { class: "dropdown-header" }, localization.Warning_InvalidVinWarningInvalidCharacterMessage),
                    (0, preact_1.h)("div", { class: "dropdown-header" }, localization.Warning_InvalidVinWarningWeFoundAlternativesIntroText), (_b = getMisreadVinDropdown()) === null || _b === void 0 ? void 0 :
                    _b.map(function (x) { return (0, preact_1.h)("div", { class: "dropdown-item", onClick: function () { return onCorrectedVinClick(x); }, className: "dropdown-item" }, x); })));
        }
    };
    return getMisreadVinDropdown().length > 0 && getFragment();
};
exports.default = VinCorrectionSelector;
